import React from 'react';

const ProjectMedia = ({ src, alt, className = '' }) => {
    const isPng = typeof src === 'string' && src.toLowerCase().includes('.png');

    return (
        <div className={`flex h-full w-full items-center justify-center bg-white ${isPng ? '' : ''} ${className}`}>
            <img
                src={src}
                alt={alt}
                className="max-h-full max-w-full object-contain"
            />
        </div>
    );
};

export default ProjectMedia;
